module.exports = __webpack_public_path__ + "static/media/Skalky.dd29ca8a.md";